import { RawTexture, Texture, type Scene } from "@babylonjs/core";
import { shoreAtlas } from "./bakes.ts";
import { SHORE_SIZE, SHORE_TILES, shoreRects } from "./shore-bake.ts";

/**
 * Terrain height and local slope around each landmass. Packed RG height keeps
 * translucent shallows smooth; B controls wash on exposed steep rock edges.
 * Atlas texels are linearly sampled without mipmaps or cross-tile bleeding.
 */
export interface ShoreMap {
  texture: RawTexture;
  tiles: number;
  /** Per landmass: centre x, centre z, half extent, unused. */
  rects: number[];
}

/** Uploads the shore atlas; `loadGameAssets` bakes it off the main thread beforehand. */
export function bakeShoreMap(scene: Scene): ShoreMap {
  const texture = RawTexture.CreateRGBATexture(shoreAtlas(), SHORE_SIZE, SHORE_SIZE, scene, false, false, Texture.BILINEAR_SAMPLINGMODE);
  texture.wrapU = Texture.CLAMP_ADDRESSMODE;
  texture.wrapV = Texture.CLAMP_ADDRESSMODE;
  texture.gammaSpace = false;
  return { texture, rects: shoreRects(), tiles: SHORE_TILES };
}
